import Typography from '@mui/material/Typography';
import { UserName } from '@callmart/types';
import { getCreatedAtForHistoryPopover } from '../../utils/dateUtils';

interface HistoryEntry {
    userId: number | null;
    value: number;
    timestamp: string;
}

interface OfferedReportHistoryProps {
    history: HistoryEntry[];
    users: UserName[];
    currentValue: number;
    currentUserId?: number;
    currentTimestamp?: Date;
}

function OfferedReportHistory({
    history,
    users,
    currentValue,
    currentUserId,
    currentTimestamp,
}: OfferedReportHistoryProps) {
    const getUserName = (userId: number | null): string => {
        if (userId === null) return 'User';
        const user = users.find((u) => u.id === userId);
        return user ? user.name : 'User';
    };

    return (
        <>
            <Typography variant="h6" style={{ textAlign: 'center', marginBottom: '.5em', paddingTop: '.5em' }}>
                Änderungen
            </Typography>

            {history && history.length > 0 ? (
                <>
                    {history.map((entry, index) => (
                        <div key={index}>
                            <Typography variant="subtitle1" textAlign={'left'} sx={{ paddingX: 2 }}>
                                <code style={{ color: 'var(--grey)' }}>
                                    {getCreatedAtForHistoryPopover(entry.timestamp).replace(' - ', ' ')}:{' '}
                                </code>
                                <span style={{ color: 'var(--primary)' }}>{entry.value}</span>
                                <span style={{ marginLeft: '0.5em' }}>{getUserName(entry.userId)}</span>
                                <span style={{ color: 'var(--grey)', marginLeft: '0.5em' }}>id: {entry.userId}</span>
                            </Typography>
                        </div>
                    ))}
                    <Typography
                        variant="subtitle1"
                        textAlign={'left'}
                        sx={{ paddingX: 2, marginTop: '1em', fontWeight: 'bold' }}
                    >
                        <code style={{ color: 'var(--grey)' }}>
                            <span>
                                {currentTimestamp
                                    ? getCreatedAtForHistoryPopover(currentTimestamp.toString()).replace(' - ', ' ')
                                    : 'Aktuell'}
                            </span>
                            :{' '}
                        </code>
                        <span style={{ color: 'var(--primary)' }}>{currentValue}</span>
                        {currentUserId && (
                            <>
                                <span style={{ marginLeft: '0.5em' }}>{getUserName(currentUserId)}</span>
                                <span style={{ color: 'var(--grey)', marginLeft: '0.5em' }}>id: {currentUserId}</span>
                            </>
                        )}
                    </Typography>
                </>
            ) : (
                <Typography variant="body2">Keine Änderungen vorhanden.</Typography>
            )}
        </>
    );
}

export default OfferedReportHistory;
